import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SalesContractTemplateGenDocLinkContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";
import {
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
} from "../../shared";

@Injectable({ providedIn: "root" })
export class SalesContractTemplateGenDocLinkService extends BaseApiTemplateService<SalesContractTemplateGenDocLinkContainerModel> {
  static readonly SALES_CONTRACT_TEMPLATE_GEN_DOC_LINK_SUBPATH =
    "sales-contract-to-gen-doc-template-links/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractTemplateGenDocLinkService.SALES_CONTRACT_TEMPLATE_GEN_DOC_LINK_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractTemplateGenDocLinkService.SALES_CONTRACT_TEMPLATE_GEN_DOC_LINK_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public createSalesContractGenDocLink(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        SalesContractTemplateGenDocLinkService.SALES_CONTRACT_TEMPLATE_GEN_DOC_LINK_SUBPATH +
        "translate-to-rrule/backoffice-ep";
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public updateSalesContractGenDocLink(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        SalesContractTemplateGenDocLinkService.SALES_CONTRACT_TEMPLATE_GEN_DOC_LINK_SUBPATH +
        "translate-to-rrule/backoffice-ep";
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
